export const AnalyticsEvent = {
  SIGN_IN: 'sign_in',
  SIGN_UP: 'sign_up',
  ONBOARDING_COMPLETE: 'onboarding_complete',
  DEMO_REQUEST: 'demo_request',
  CONTACT_US: 'contact_us',
  THREAD_CREATE: 'thread_create',
};
